// extracted by mini-css-extract-plugin
export default {"wrapper":"xq-z","response":"yq-z","error":"zq-z","disabled":"Aq-z","buttons":"Bq-z","feedbackQuestionSection":"Cq-z","yesNoWrapper":"Dq-z"};